<div *ngIf="!selectedPlan">
  <div class="pricing-shell">
    <div class="pricing-grid">
      <article
        *ngFor="let plan of pricingCards"
        class="pricing-card"
        [ngClass]="{
          'pricing-card--recommended': plan.recommended,
          'pricing-card--enterprise': plan.enterprise
        }"
      >
        <div *ngIf="plan.recommended" class="pricing-badge">Recommended</div>

        <div class="pricing-card__header">
          <h2 class="pricing-card__title">{{ plan.title }}</h2>
          <p class="pricing-card__subtitle">{{ plan.subtitle }}</p>
        </div>

        <div class="pricing-card__deposit">
          <span class="deposit-label">{{ plan.depositLabel }}</span>
          <div class="deposit-amount">{{ plan.depositAmount }}</div>
          <p class="deposit-support">{{ plan.depositSupport }}</p>
          <div
            class="pricing-card__callout"
            [class.pricing-card__callout--active]="plan.enterprise"
          >
            <span *ngIf="plan.enterprise">Volume discounts available for over USD 100,000</span>
          </div>
        </div>

        <button type="button" class="pricing-cta" (click)="planClick(plan.planId)">GET ACCESS</button>
        <div class="pricing-card__cta-divider" aria-hidden="true"></div>

        <div *ngIf="!plan.enterprise; else enterpriseSensorSummary" class="pricing-accordion" [class.is-open]="isPricingAccordionOpen(plan.planId)">
          <button
            type="button"
            class="pricing-accordion__toggle"
            (click)="togglePricingAccordion(plan.planId)"
            [attr.aria-expanded]="isPricingAccordionOpen(plan.planId)"
          >
            <span class="pricing-accordion__heading-wrap">
              <span class="pricing-accordion__heading-block">
                <span class="pricing-accordion__heading-line">
                  <span class="pricing-accordion__heading">{{ plan.sensorHeading }}</span>
                </span>
                <span class="pricing-accordion__subtext">{{ plan.sensorSubtext }}</span>
              </span>
            </span>
            <span class="pricing-accordion__meta">
              <span class="pricing-accordion__count">{{ plan.sensorCount }}</span>
              <mat-icon class="pricing-accordion__arrow">expand_more</mat-icon>
            </span>
          </button>

          <div class="pricing-accordion__body">
            <div class="pricing-accordion__body-inner">
              <div class="sensor-list">
                <div *ngFor="let sensor of plan.sensorItems" class="sensor-list__item">
                  <span class="sensor-text" [ngClass]="'sensor-text--' + sensor.category">{{ sensor.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #enterpriseSensorSummary>
          <div class="pricing-enterprise-summary">
            {{ plan.enterpriseSensorSummary }}
          </div>
        </ng-template>

        <div class="feature-list" [ngClass]="{ 'feature-list--enterprise': plan.enterprise }">
          <div class="feature-list__heading">{{ plan.featureHeading }}</div>
          <div *ngFor="let feature of plan.features" class="feature-list__item">
            <mat-icon class="feature-list__icon" aria-hidden="true">check_circle</mat-icon>
            <span>{{ feature }}</span>
          </div>
        </div>
      </article>
    </div>

  </div>
</div>
<div *ngIf="selectedPlan" class="container userRegister">
    <div class="register-header">
      <div class="register-header__row1">
        <img *ngIf="!isInIframe" src="../../../assets/images/logo.png" alt="logo" class="register-header__logo" />
      </div>
      <div class="register-header__row2">
        <div>
          <div class="register-header__headline">Discover earth with us</div>
          <div class="register-header__subline">Start Here to Solve the Hardest Problems</div>
        </div>
      </div>
    </div>

    <div class="vstep">
      <div class="vstep__track">
        <div class="vstep__circle" [ngClass]="{'vstep__circle--active': currentStep === 1, 'vstep__circle--done': currentStep > 1}">
          <mat-icon *ngIf="currentStep > 1" class="vstep__check">check</mat-icon>
          <span *ngIf="currentStep <= 1">1</span>
        </div>
        <div class="vstep__line" [ngClass]="{'vstep__line--done': currentStep > 1}"></div>
        <div class="vstep__circle" [ngClass]="{'vstep__circle--active': currentStep === 2, 'vstep__circle--done': currentStep > 2}">
          <mat-icon *ngIf="currentStep > 2" class="vstep__check">check</mat-icon>
          <span *ngIf="currentStep <= 2">2</span>
        </div>
        <div class="vstep__line" [ngClass]="{'vstep__line--done': currentStep > 2}"></div>
        <div class="vstep__circle" [ngClass]="{'vstep__circle--active': currentStep === 3}">
          <span>3</span>
        </div>
      </div>
      <div class="vstep__labels">
        <span class="vstep__lbl" [ngClass]="{'vstep__lbl--active': currentStep === 1}">Personal</span>
        <span class="vstep__lbl" [ngClass]="{'vstep__lbl--active': currentStep === 2}">Organisation</span>
        <span class="vstep__lbl" [ngClass]="{'vstep__lbl--active': currentStep === 3}">Account</span>
      </div>
    </div>

    <div *ngIf="currentStep === 1" class="kyc-banner">
      <mat-icon class="kyc-banner__icon">info</mat-icon>
      <span>The registration details used for the know-your-customer (KYC) verification process will take under three minutes. The mandatory fields are identified by ' <strong style="color: red;font-size: 14px;">*</strong> '.</span>
    </div>

    <div *ngIf="draftRestoreMsg && currentStep === 1" class="draft-restore-msg">{{ draftRestoreMsg }}</div>
    <div *ngIf="draftExistsMsg && currentStep === 1" class="draft-exists-msg">
      <mat-icon class="draft-exists-msg__icon">mail_outline</mat-icon>
      <span>{{ draftExistsMsg }}</span>
    </div>

    <form *ngIf="currentStep === 1" class="form-vertical" [formGroup]="registerForm" (ngSubmit)="goToStep2()">

      <div class="register-wrapper field-grid">
        <div class="form-group">
          <mat-label>Email<span>*</span></mat-label>
          <mat-form-field appearance="outline" [class.field-warn]="f.email.errors?.emailTaken && f.email.touched">

            <input matInput type="text" placeholder="Your email" formControlName="email" ngForm=""
              (keypress)="keyPress($event)" (keydown)="Space($event)"
              [ngClass]="{ 'is-invalid': f.email.errors && f.email.touched }" />
            <mat-error *ngIf="f.email.touched && f.email.errors" class="alert alert-danger">
              <mat-error *ngIf="f.email.errors.required">Email is required.</mat-error>
              <mat-error *ngIf="f.email.errors.pattern">Please use an official email address.</mat-error>
              <mat-error *ngIf="f.email.errors.emailTaken">This email is already registered. Please sign in instead.</mat-error>
            </mat-error>
            <mat-icon matSuffix *ngIf="f.email.status === 'PENDING'"
              style="font-size:16px;color:#9ca3af;animation:spin 1s linear infinite;">sync</mat-icon>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-label>Display Name<span>*</span></mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Your display name in the platform" formControlName="displayName" ngForm=""
              [ngClass]="{ 'is-invalid': f.displayName.errors && f.displayName.touched }"
              (keypress)="utilsService.keyPressValidation($event)" (keydown)="Space($event)" />

            <mat-error *ngIf="f.displayName.touched && f.displayName.errors" class="alert alert-danger">
              <mat-error *ngIf="f.displayName.errors.required"> Display Name is required.</mat-error>
              <mat-error *ngIf="f.displayName.hasError('minlength') && !f.displayName.hasError('specialChars')"> At least 3 characters long.</mat-error>
              <mat-error *ngIf="f.displayName.hasError('maxlength') && !f.displayName.hasError('specialChars')"> Maximum 15 characters long.</mat-error>
              <mat-error *ngIf="!f.displayName.errors.required && f.displayName.hasError('specialChars')"> Only the following special characters are allowed: space, hyphen and apostrophe.</mat-error>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-label>First Name<span>*</span></mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Your first name" formControlName="fullName" ngForm=""
              (keypress)="utilsService.keyPressValidation($event)" (keydown)="Space($event)"
              [ngClass]="{ 'is-invalid': f.fullName.errors && f.fullName.touched }" />
            <mat-error *ngIf="f.fullName.touched && f.fullName.errors" class="alert alert-danger">
              <mat-error *ngIf="f.fullName.errors.required"> Your First Name is required.</mat-error>
              <mat-error *ngIf="!f.fullName.errors.required && f.fullName.hasError('specialChars')"> Only the following special characters are allowed: space, hyphen and apostrophe.</mat-error>
              <mat-error *ngIf="f.fullName.hasError('minlength') && !f.fullName.hasError('specialChars')"> At least 3 characters long.</mat-error>
              <mat-error *ngIf="f.fullName.hasError('maxlength') && !f.fullName.hasError('specialChars')"> Maximum 50 characters long.</mat-error>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-label>Last Name<span>*</span></mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Your last name" formControlName="lastName" ngForm=""
              (keypress)="utilsService.keyPressValidation($event)" (keydown)="Space($event)"
              [ngClass]="{ 'is-invalid': f.lastName.errors && f.lastName.touched }" />
            <mat-error *ngIf="f.lastName.touched && f.lastName.errors" class="alert alert-danger">
              <mat-error *ngIf="f.lastName.errors.required"> Your Last Name is required.</mat-error>
              <mat-error *ngIf="f.lastName.hasError('maxlength') && !f.lastName.hasError('specialChars')"> Maximum 50 characters long.</mat-error>
              <mat-error *ngIf="!f.lastName.errors.required && f.lastName.hasError('specialChars')"> Only the following special characters are allowed: space, hyphen and apostrophe.</mat-error>
            </mat-error>
          </mat-form-field>
        </div>

      </div>

      <div *ngIf="stepErrorMsg" class="step-error-msg">{{ stepErrorMsg }}</div>
      <div class="step-footer">
        <button type="button" mat-stroked-button class="step-footer__save"
          [disabled]="!registerForm.get('email')?.valid"
          [ngClass]="{'draft-btn--saved': draftSavedState === 'saved', 'draft-btn--error': draftSavedState === 'error'}"
          (click)="saveDraft()">
          <mat-icon *ngIf="draftSavedState === 'saved'">check</mat-icon>
          <mat-icon *ngIf="draftSavedState === 'error'">error_outline</mat-icon>
          {{ draftSavedState === 'saving' ? 'SAVING…' : draftSavedState === 'saved' ? 'SAVED!' : draftSavedState === 'error' ? 'TRY AGAIN' : 'SAVE &amp; RESUME LATER' }}
        </button>
        <button type="button" mat-raised-button color="primary" id="button" (click)="goToStep2()">NEXT</button>
      </div>
    </form>

    <form *ngIf="currentStep > 1" class="form-vertical" [formGroup]="signupform" (ngSubmit)="submitSignup()">

      <div *ngIf="currentStep === 2">

        <div class="field-grid">

          <!-- Row 1: Organisation Name | Department -->
          <div>
            <mat-label>Organisation Name<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <input matInput type="text" placeholder="Your organisation name" formControlName="companyName"
                (keydown)="Space($event)" id="company" />
              <mat-error *ngIf="sign.companyName.errors && sign.companyName.touched" class="alert alert-danger">
                <mat-error *ngIf="sign.companyName.errors.required">Organisation name is required.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-label>Department<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <input matInput type="text" placeholder="Your department" formControlName="department"
                (keydown)="Space($event)" />
              <mat-error *ngIf="sign.department.errors && sign.department.touched" class="alert alert-danger">
                <mat-error *ngIf="sign.department.errors.required">Department is required.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Row 2: Role/Position | Organisation Type -->
          <div>
            <mat-label>Role/Position<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <input matInput type="text" placeholder="Your role/position" formControlName="role"
                (keydown)="Space($event)" />
              <mat-error *ngIf="sign.role.errors && sign.role.touched" class="alert alert-danger">
                <mat-error *ngIf="sign.role.errors.required">Role/Position is required.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-label>Organisation Type<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <mat-select [disableOptionCentering]="true" panelClass="matopencountry" formControlName="organisationType"
                placeholder="Choose organisation type" [ngClass]="{ 'is-invalid': sign.organisationType.errors && sign.organisationType.touched }"
                (selectionChange)="onOrgTypeChange($event)" [compareWith]="compareOrgType">
                <mat-option *ngFor="let type of organisationTypes" [value]="type"
                  [matTooltip]="getOrgTypeTooltip(type.name)" matTooltipPosition="right">
                  {{type.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="sign.organisationType.errors && sign.organisationType.touched" class="alert alert-danger">
                <mat-error *ngIf="sign.organisationType.errors.required">Organisation type is required.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Row 3: Please specify (conditional) | Website -->
          <div *ngIf="sign.organisationType.value?.key === 'other'" class="org-type-other">
            <mat-label>Please specify<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <input matInput type="text" placeholder="Enter your organisation type" formControlName="organisationTypeOther"
                maxlength="15" />
              <mat-error *ngIf="sign.organisationTypeOther.errors && sign.organisationTypeOther.touched" class="alert alert-danger">
                <mat-error *ngIf="sign.organisationTypeOther.errors.required">Please specify your organisation type.</mat-error>
                <mat-error *ngIf="sign.organisationTypeOther.errors.maxlength">Maximum 15 characters allowed.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-label>Website<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <input matInput type="text" placeholder="Your website" formControlName="website"
                (keydown)="Space($event)" id="website" />
              <mat-error *ngIf="sign.website.errors && sign.website.touched" class="alert alert-danger">
                <mat-error *ngIf="sign.website.errors.required">Website is required.</mat-error>
                <mat-error *ngIf="sign['website'].errors?.['pattern']">Please enter a valid website.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Row 4: Phone Number -->
          <div>
            <label>Phone Number<span>*</span></label>
            <ngx-intl-tel-input
              [cssClass]="'form-control phone-input'"
              [preferredCountries]="[]"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
              [selectFirstCountry]="false"
              [maxLength]="15"
              [phoneValidation]="true"
              [separateDialCode]="true"
              formControlName="phonenumber"
              [ngClass]="{ 'is-invalid': sign.phonenumber.errors && sign.phonenumber.touched }">
            </ngx-intl-tel-input>
            <div *ngIf="sign.phonenumber.errors && sign.phonenumber.touched" class="alert alert-danger align">
              <div *ngIf="sign.phonenumber.errors.required"> Phone number is required.</div>
              <div *ngIf="sign.phonenumber.errors.validatePhoneNumber"> Please enter a valid phone number.</div>
            </div>
          </div>

        </div>

        <div *ngIf="stepErrorMsg" class="step-error-msg">{{ stepErrorMsg }}</div>
        <div class="step-footer">
          <button type="button" mat-stroked-button color="step-footer__save" (click)="goToPrevious()">BACK</button>
          <button type="button" mat-stroked-button class="step-footer__save"
            [disabled]="!registerForm.get('email')?.valid"
            [ngClass]="{'draft-btn--saved': draftSavedState === 'saved', 'draft-btn--error': draftSavedState === 'error'}"
            (click)="saveDraft()">
            <mat-icon *ngIf="draftSavedState === 'saved'">check</mat-icon>
            <mat-icon *ngIf="draftSavedState === 'error'">error_outline</mat-icon>
            {{ draftSavedState === 'saving' ? 'SAVING…' : draftSavedState === 'saved' ? 'SAVED!' : draftSavedState === 'error' ? 'TRY AGAIN' : 'SAVE &amp; RESUME LATER' }}
          </button>
          <button type="button" mat-raised-button color="primary" (click)="goToStep3()">NEXT</button>
        </div>
      </div>

      <div *ngIf="currentStep === 3">
        <div class="field-grid">
          <div>
            <mat-label>Password<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <input matInput [type]="showPassword ? 'password' : 'text'" placeholder="Your password" formControlName="password"
                (keydown)="Space($event)" />
              <mat-icon matSuffix (click)="togglePasswordVisibility()" style="cursor:pointer;">
                {{ showPassword ? "visibility_off" : "visibility" }}
              </mat-icon>
              <mat-error *ngIf="sign['password'].touched && sign['password'].invalid" class="alert alert-danger">
                <mat-error *ngIf="sign['password'].errors?.['required']">Password is required.</mat-error>
                <mat-error class="passerror" *ngIf="sign['password'].errors?.['minlength'] || sign['password'].errors?.['pattern']">
                  Must contain minimum 8 characters with at least one capital letter and a special character.
                </mat-error>
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-label>Confirm Password<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <input matInput [type]="confirmshowPassword ? 'password' : 'text'" placeholder="Confirm your password"
                formControlName="confirm_password"
                (keydown)="Space($event)" />
              <mat-icon matSuffix (click)="toggleconfirmPasswordVisibility()" style="cursor:pointer;">
                {{ confirmshowPassword ? "visibility_off" : "visibility" }}
              </mat-icon>
              <mat-error *ngIf="sign['confirm_password'].touched && sign['confirm_password'].invalid" class="alert alert-danger">
                <mat-error *ngIf="sign['confirm_password'].errors?.['required']">Password confirmation is required.</mat-error>
                <mat-error *ngIf="sign['confirm_password'].errors?.['confirmedValidator']">The passwords must be the same.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="address field-grid__full">
            <label>Address<span>*</span></label>
            <mat-form-field appearance="outline">
              <input matInput placeholder="Address line 1" formControlName="address1" type="text"
                (keydown)="Space($event)" />
              <mat-hint>Should not be a PO or GPO box address.</mat-hint>
              <mat-error *ngIf="sign.address1.errors && sign.address1.touched" class="alert alert-danger">
                <mat-error *ngIf="sign.address1.errors.required">Address is required.</mat-error>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input matInput placeholder="Address line 2 (optional)" formControlName="address2" type="text"
                (keydown)="Space($event)" />
            </mat-form-field>
          </div>
          <div>
            <mat-label>City<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <input matInput placeholder="City" formControlName="city" type="text"
                (keydown)="Space($event)" />
              <mat-error *ngIf="sign.city.errors && sign.city.touched" class="alert alert-danger">
                <mat-error *ngIf="sign.city.errors.required">City is required.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-label>Zip Code<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <input matInput placeholder="Zip Code" formControlName="zip_code" type="number" />
              <mat-error *ngIf="sign.zip_code.errors && sign.zip_code.touched" class="alert alert-danger">
                <mat-error *ngIf="sign.zip_code.errors.required">Zip Code is required.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-label>Country<span>*</span></mat-label>
            <mat-form-field appearance="outline">
              <mat-select [disableOptionCentering]="true" panelClass="matopencountry" formControlName="country"
                placeholder="Choose country" [ngClass]="{ 'is-invalid': sign.country.errors && sign.country.touched }"
                [compareWith]="compareCountry" (closed)="onCountryPanelClose()">
                <mat-option class="country-search-option" (click)="$event.stopPropagation()">
                  <input type="text" class="country-filter-input" placeholder="Search country..."
                    [formControl]="countryFilterCtrl"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()" />
                </mat-option>
                <mat-option *ngFor="let country of filteredCountries" [value]="country">
                  {{country.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="sign.country.errors && sign.country.touched" style="font-weight: 600; font-size: 10px; color: red;">
                <mat-error *ngIf="sign.country.errors.required"> Country is required.</mat-error>
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="selectedPlan === '2' || selectedPlan === '3' || selectedPlan === '4'" class="quote-cell">
            <span>If you need a quote, <b (click)="requestQuotation()">Click here</b></span>
          </div>
        </div>

          <div>

            <!-- <div style="padding-bottom: 15px;" class="radio-items">
              <mat-radio-button 
              [checked]="selectedOption === 'withDeposit'" 
              (click)="acceptSubscription('withDeposit')"
              class="small-radio-button">
              Access platform with deposit.
              <img 
                style="margin-left: 5px;margin-top: -4px;" width="15px" [src]="tooltipImagePath"
                matTooltip="The full access is based on a minimum deposit of U$5000 as credit, which will need to be paid after the registration is confirmed." 
              />
            </mat-radio-button>

          
            <mat-radio-button 
              [checked]="selectedOption === 'withoutDeposit'" 
              (click)="acceptSubscription('withoutDeposit')"
              class="small-radio-button">
              Access platform without deposit.
              <img 
                style="margin-left: 5px;margin-top: -4px;" width="15px;" [src]="tooltipImagePath"
                matTooltip="Access without deposit is limited to one or more sensors and functionality." 
              />
            </mat-radio-button>
            </div> -->
            <div class="terms" id="term" style="padding-bottom: 17px;">
              <mat-checkbox [checked]="check" (click)="OpenPopup($event)">
                <span>Accept the
                  <b>Terms of Use</b></span>
              </mat-checkbox>
            </div>

        <div *ngIf="registerBlockedMsg" class="register-blocked-msg">{{ registerBlockedMsg }}</div>
        <div class="step-footer">
          <button type="button" mat-stroked-button color="step-footer__save" (click)="goToPrevious()">BACK</button>
          <button type="button" mat-stroked-button class="step-footer__save"
            [disabled]="!registerForm.get('email')?.valid"
            [ngClass]="{'draft-btn--saved': draftSavedState === 'saved', 'draft-btn--error': draftSavedState === 'error'}"
            (click)="saveDraft()">
            <mat-icon *ngIf="draftSavedState === 'saved'">check</mat-icon>
            <mat-icon *ngIf="draftSavedState === 'error'">error_outline</mat-icon>
            {{ draftSavedState === 'saving' ? 'SAVING…' : draftSavedState === 'saved' ? 'SAVED!' : draftSavedState === 'error' ? 'TRY AGAIN' : 'SAVE &amp; RESUME LATER' }}
          </button>
          <button type="submit" mat-raised-button color="primary" [disabled]="register" id="buttons">REGISTER</button>
        </div>
          </div>
      </div>
    </form>

    <div class="reg-links">
      <a (click)="onResetClick($event)" routerLink="/login">Already registered? <span>Sign in</span></a>
      <a (click)="onResetClick($event)">Want to change the plan? <span>Click here</span></a>
    </div>
</div>
<ng-template #tooltipTemplate let-data>
  <div class="custom-tooltip-box">
    <app-custom-tooltip [metadata]="data.accessDetails" product="planUpgrade"></app-custom-tooltip>
  </div>
</ng-template>

<ng-template #draftSavedDialogTpl>
  <div style="text-align:center; padding: 20px 8px 4px;">
    <mat-icon style="font-size:52px; height:52px; width:52px; color:#1976d2;">mark_email_unread</mat-icon>
    <h2 style="margin: 12px 0 6px; font-size:18px; font-weight:600; color:#1a1a2e;">Draft Saved</h2>
  </div>
  <mat-dialog-content style="text-align:center; color:#555; font-size:14px; line-height:1.7; padding-bottom:8px;">
    A resume link has been sent to
    <strong>{{ registerForm.get('email')?.value }}</strong>.<br/>
    Click the link in the email to continue your registration at any time.
  </mat-dialog-content>
  <mat-dialog-actions align="center" style="padding-bottom:20px;">
    <button mat-flat-button (click)="draftSavedDialogRef.close()">Ok, Thanks</button>
  </mat-dialog-actions>
</ng-template>